<section class="section breadcrumb-area overlay-dark d-flex align-items-center">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- Breamcrumb Content -->
                <div class="breadcrumb-content d-flex flex-column align-items-center text-center">
                    <h2 class="text-white text-uppercase mb-3">{{currTitle}}</h2>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a class="text-uppercase text-white" href="index.html">Home</a></li>
                        <li class="breadcrumb-item"><a class="text-uppercase text-white" [routerLink]="'/services'">Services</a></li>
                        <li class="breadcrumb-item text-white active">{{currTitle}}</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="blog" class="section blog-area ptb_100">
    <div class="container" style="padding-bottom: 150px;">
        <div class="row">
            <div class="col-12 col-lg-3" fxHide.lt-sm fxShow.gt-md>
                <aside class="sidebar mb-5 mb-lg-0">
                    <div class="single-widget">
                        <div class="widget post-widget">
                            <h5 class="text-uppercase d-block py-3">Other Services</h5>
                            <div class="widget-content">
                                <ul class="widget-items">
                                    <li *ngFor="let service of fullServiceList">
                                        <a *ngIf="service.hideBlogPost === undefined" [routerLink]="'/services/post/'+service.link" class="single-post media py-3" [class.disabled]="service.title === currTitle">
                                            <div class="post-thumb avatar-lg h-100 d-flex align-self-center">
                                                <img src="{{service.image}}" alt="">
                                            </div>
                                            <div class="post-content media-body ml-3 py-2">
                                                <h6>{{service.title}}</h6>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
            <div class="col-12 col-lg-9">
                <router-outlet></router-outlet>
            </div>
            <div class="col-12 col-lg-3" fxHide.gt-sm fxShow.lt-md>
                <aside class="sidebar mb-5 mb-lg-0">
                    <div class="single-widget">
                        <div class="widget post-widget">
                            <h5 class="text-uppercase d-block py-3">Other Services</h5>
                            <div class="widget-content">
                                <ul class="widget-items">
                                    <li *ngFor="let service of fullServiceList">
                                        <a [routerLink]="'/services/post/'+service.link" class="single-post media py-3" [class.disabled]="service.title === currTitle">
                                            <div class="post-thumb avatar-lg h-100 d-flex align-self-center">
                                                <img src="{{service.image}}" alt="">
                                            </div>
                                            <div class="post-content media-body ml-3 py-2">
                                                <h6>{{service.title}}</h6>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </div>
    
    <div class="shape shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#f5f5f4">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
</section>


<section id="contact" class="contact-area bg-grey ptb_100">
    
    <app-contact-form></app-contact-form>
</section>
